import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudWeather: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCloudWeather"><Path d="M17.125 19.25H8.925C4.96236 19.25 1.75 16.0041 1.75 12C1.75 7.99594 4.96236 4.75 8.925 4.75C11.5605 4.75 13.8642 6.18583 15.1116 8.32557C15.3741 8.77588 15.9058 9.01272 16.4221 8.94116C16.6519 8.90931 16.8865 8.89286 17.125 8.89286C19.9555 8.89286 22.25 11.2114 22.25 14.0714C22.25 16.9315 19.9555 19.25 17.125 19.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCloudWeather;
